import { EDatePickerMode } from '../types'
import { Dayjs } from 'dayjs'
import { dt } from '../vendor'


export const getNowInMs = () => Date.now() // returns the number of milliseconds since January 1, 1970.

/**
 * Get pre-defined date range values according to the selected mode
 *
 * @param {EDatePickerMode | null} mode - selected mode
 * @return {[Dayjs | null, Dayjs | null]} - date range values
 */
export const getDateRange = (
	mode: EDatePickerMode | null
): [Dayjs | null, Dayjs | null] => {
	let startDate: Dayjs | null = null
	let endDate: Dayjs | null = null

	switch (mode) {
		case EDatePickerMode.today: {
			startDate = dt().startOf('day')
			endDate = dt().endOf('day')
			break
		}
		case EDatePickerMode.yesterday: {
			startDate = dt().subtract(1, 'day').startOf('day')
			endDate = dt().subtract(1, 'day').endOf('day')
			break
		}
		case EDatePickerMode.currentWeek: {
			startDate = dt().startOf('week')
			endDate = dt().endOf('week')
			break
		}
		case EDatePickerMode.last7Days: {
			startDate = dt().subtract(7, 'day').startOf('day')
			endDate = dt().subtract(1, 'day').endOf('day')
			break
		}
		case EDatePickerMode.currentMonth: {
			startDate = dt().startOf('month')
			endDate = dt().endOf('month')
			break
		}
		case EDatePickerMode.lastMonth: {
			// TODO: check if correct logic for short/long month-s ...?!
			startDate = dt().subtract(1, 'month').startOf('month')
			endDate = dt().subtract(1, 'month').endOf('month')
			break
		}
		case EDatePickerMode.last30Days: {
			startDate = dt().subtract(30, 'day').startOf('day')
			endDate = dt().subtract(1, 'day').endOf('day')
			break
		}
		case EDatePickerMode.currentYear: {
			startDate = dt().startOf('year')
			endDate = dt().endOf('year')
			break
		}
		case EDatePickerMode.pastYear: {
			startDate = dt().startOf('year').subtract(1, 'year')
			endDate = dt().endOf('year').subtract(1, 'year')
			break
		}
		default: {
			throw new Error(`helper.time.getDateRange:: No such case for mode = ${mode}`)
		}
	}
	// re-calculate endDate - min between endDate and today
	endDate = endDate ? dt.min(endDate, dt().endOf('day')) : null
	return [startDate, endDate]
}